import React from 'react';
import { FileCheck, Shield, AlertCircle } from 'lucide-react';

const EngagementModel = () => {
  const engagementModes = [
    'Vendor-to-vendor staffing and augmentation',
    'Contract workforce support',
    'Consulting under SOW'
  ];

  const processSteps = [
    {
      number: '01',
      title: 'Requirement Intake',
      description: 'Via vendor/MSP/client'
    },
    {
      number: '02',
      title: 'Candidate Identification',
      description: 'Screening support (as applicable)'
    },
    {
      number: '03',
      title: 'Interview Coordination',
      description: 'Scheduling and communication support'
    },
    {
      number: '04',
      title: 'Documentation + Onboarding',
      description: 'Confirmation and required documentation'
    },
    {
      number: '05',
      title: 'Timesheets + Invoicing',
      description: 'As applicable per agreement'
    }
  ];

  const controls = [
    'No onboarding without documented confirmation',
    'No payroll commitment without executed agreement / written approval',
    'No backdated invoices',
    'No verbal-only commitments'
  ];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">Engagement Model</h1>
            <p className="text-xl text-gray-600">
              Structured processes designed for vendor-to-vendor collaboration.
            </p>
          </div>
        </div>
      </section>

      {/* Engagement Modes */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="flex items-center justify-center mb-8">
          <FileCheck size={32} className="text-blue-900 mr-4" />
          <h2 className="text-3xl font-bold text-gray-900">Engagement Modes Supported</h2>
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {engagementModes.map((mode, index) => (
            <div key={index} className="flex items-start bg-gray-50 p-6 rounded-lg border border-gray-200">
              <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 mr-4 flex-shrink-0"></div>
              <p className="text-lg text-gray-700">{mode}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Process Steps */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Process</h2>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            {processSteps.map((step, index) => (
              <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-4xl font-bold text-blue-900 mb-4">{step.number}</div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-sm text-gray-600">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Controls */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="flex items-center justify-center mb-8">
          <Shield size={32} className="text-blue-900 mr-4" />
          <h2 className="text-3xl font-bold text-gray-900">Controls</h2>
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {controls.map((control, index) => (
            <div key={index} className="flex items-start bg-red-50 p-6 rounded-lg border border-red-200">
              <AlertCircle size={20} className="text-red-700 mr-3 mt-1 flex-shrink-0" />
              <p className="text-lg text-gray-900">{control}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default EngagementModel;